import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { DifferenceHero } from './components/Hero'
import { DifferenceCustomDevelopment } from './components/CustomDevelopment'
import { DifferenceEmbeddedIPaaS } from './components/EmbeddedIPaaS'
import { DifferenceUnifiedAPI } from './components/UnifiedAPI'
import { DifferenceConsistent } from './components/Consistent'
import { DifferenceSetup } from './components/Setup'
import { DifferenceSolution } from './components/Solution'
import { DifferenceEvaluation } from './components/Evaluation'
import { DifferenceComparison } from './components/Comparison'
import classes from './HowWeAreDifferent.module.scss'

export default function HowWeAreDifferentPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'How We Are Different'} />
      <Container grid>
        <DifferenceHero />
        <DifferenceCustomDevelopment />
        <DifferenceEmbeddedIPaaS />
        <DifferenceUnifiedAPI />
        <DifferenceConsistent />
        <DifferenceSetup />
        <DifferenceSolution />
        <DifferenceEvaluation />
        <DifferenceComparison />
      </Container>
    </DefaultPageLayout>
  )
}
